import React from "react";

const Selector = ({ onSelect, icon, title, width }) => {
  //const iconSize = size || "big";
  //const iconColor = color || "grey";
  //const select = className ? `${icon} ${className}` : icon;
  return (
    <button
      onClick={() => onSelect(icon, width, title)}
      className={icon}
      title={title}
    />
  );
};

export default Selector;
